import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Traducciones generales del sitio
import translationEN from './locales/en.json';
import translationES from './locales/es.json';

// Traducciones específicas para los artículos del blog
import blogResponsiveDataEn from '../data/blogResponsiveEn.json';
import blogResponsiveDataEs from '../data/blogResponsiveEs.json';

// Traducciones para el banner del blog
import blogBannerEn from '../data/blogBannerEn.json';
import blogBannerEs from '../data/blogBannerEs.json';

// Mapea idiomas soportados
const languageMap = {
  "en": "en",
  "en-US": "en",
  "en-GB": "en",
  "es": "es",
  "es-ES": "es",
  "es-MX": "es",
  "es-419": "es",
};

const getLanguage = () => {
  const savedLang = localStorage.getItem("i18nextLng");
  if (savedLang && languageMap[savedLang]) return savedLang;
  const detectedLang = navigator.language || "en";
  return languageMap[detectedLang] || "en";
};

const resources = {
  en: {
    translation: translationEN,
    blogResponsive: blogResponsiveDataEn,
    blogBanner: blogBannerEn,
  },
  es: {
    translation: translationES,
    blogResponsive: blogResponsiveDataEs,
    blogBanner: blogBannerEs,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    ns: ['translation', 'blogResponsive', 'blogBanner'],
    defaultNS: 'translation',
    lng: getLanguage(),
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: ['en', 'es'],
    nonExplicitSupportedLngs: true,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
